<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="公司ID,关联{sys_dept.id}" prop="companyId">
        <a-input
          v-model:value="form.companyId"
          placeholder="请输入公司ID,关联{sys_dept.id}"
        />
      </a-form-model-item>
      <a-form-model-item
        label="项目ID,关联{zb_project_info.id}"
        prop="projectId"
      >
        <a-input
          v-model:value="form.projectId"
          placeholder="请输入项目ID,关联{zb_project_info.id}"
        />
      </a-form-model-item>
      <a-form-model-item label="空间ID,关联{zb_space.id}" prop="spaceId">
        <a-input
          v-model:value="form.spaceId"
          placeholder="请输入空间ID,关联{zb_space.id}"
        />
      </a-form-model-item>
      <a-form-model-item label="空间名称" prop="spaceName">
        <a-input v-model:value="form.spaceName" placeholder="请输入空间名称" />
      </a-form-model-item>
      <a-form-model-item label="员工ID,关联{sys_user.id}" prop="employeeId">
        <a-input
          v-model:value="form.employeeId"
          placeholder="请输入员工ID,关联{sys_user.id}"
        />
      </a-form-model-item>
      <a-form-model-item label="员工名" prop="employeeName">
        <a-input v-model:value="form.employeeName" placeholder="请输入员工名" />
      </a-form-model-item>
      <a-form-model-item label="日期" prop="stayDate"> </a-form-model-item>
      <a-form-model-item label="总时长" prop="stayDuration">
        <a-input v-model:value="form.stayDuration" placeholder="请输入总时长" />
      </a-form-model-item>
      <a-form-model-item label="进入次数" prop="stayTimes">
        <a-input v-model:value="form.stayTimes" placeholder="请输入进入次数" />
      </a-form-model-item>
      <a-form-model-item label="平均时长" prop="avgDuration">
        <a-input
          v-model:value="form.avgDuration"
          placeholder="请输入平均时长"
        />
      </a-form-model-item>
      <a-form-model-item
        label="空间性质(固定打卡点、单人任务、多人任务、机动任务)"
        prop="spatialProperties"
      >
        <a-input
          v-model:value="form.spatialProperties"
          placeholder="请输入空间性质(固定打卡点、单人任务、多人任务、机动任务)"
        />
      </a-form-model-item>
      <a-form-model-item label="状态 1显示 0-不显示" prop="status">
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model:value="form.sort" placeholder="请输入排序" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input
          v-model:value="form.remark"
          placeholder="请输入内容"
          type="textarea"
          allow-clear
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import {
  getSpaceStay,
  addSpaceStay,
  updateSpaceStay,
} from '@/api/system/spaceStay'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        companyId: null,

        projectId: null,

        spaceId: null,

        spaceName: null,

        employeeId: null,

        employeeName: null,

        stayDate: null,

        stayDuration: null,

        stayTimes: null,

        avgDuration: null,

        spatialProperties: null,

        status: 0,

        sort: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
      },
    }
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        companyId: null,
        projectId: null,
        spaceId: null,
        spaceName: null,
        employeeId: null,
        employeeName: null,
        stayDate: null,
        stayDuration: null,
        stayTimes: null,
        avgDuration: null,
        spatialProperties: null,
        status: 0,
        sort: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSpaceStay({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSpaceStay(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addSpaceStay(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>
